import { Component, OnInit } from "@angular/core";
import { SiAuthenticationService } from "@strategic-insights/ng-authentication";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "si-unauthorized",
  templateUrl: "./si-unauthorized.component.html",
  styleUrls: ["./si-unauthorized.component.scss"],
})

export class SiUnauthorizedComponent implements OnInit {
  getClass: string = "warning";
  getContent: string = "You do not have permission to access this page.";
  constructor  (private siAuthenticationService : SiAuthenticationService, private route: ActivatedRoute, private router: Router) {
    this.route.queryParams.subscribe({
      next: (params) => {
        this.getClass = params.getClass ? params.getClass : this.getClass;
        this.getContent = params.content ? params.content : this.getContent;
      },
    });
  }
  ngOnInit() {}

  logout() {
   // this.siAuthenticationService.logout().subscribe({ next: () => {} });
   this.router.navigate(['/kclogoutredirect'], { queryParams: {logout : true}});
  }
}
